import styled from 'styled-components';

const TITLE_COLOR = '#09488a';

export const ToolbarContainer = styled.div`
  margin-bottom: 16px;
`;

export const PageTitle = styled.div`
  h3 {
    font-weight: bold;
    color: ${TITLE_COLOR};
  }
`;
